export const LOT_ALREADY_SOLD_API_ERROR_MSG = 'Lot was already sold.';
